import services from '../utils/services';
import client from '../utils/client';

export async function loadStatisticsApi(companyId, params) {
  return client.get(
    `${services.companies}${companyId}${services.getStatistics}`,
    { params }
  );
}
